/**
 * Chip — the single pill/badge shape used across the app.
 *
 * Pass an explicit semantic `bg` + `color`, or a single `tone` to derive a
 * soft tint automatically. `size="xs"` is the compact micro-tag variant
 * (e.g. Owner / Claimed); default is the standard chip (status, type, etc.).
 */
export default function Chip({ bg, color, tone, size = 'sm', className = '', style, children, ...rest }) {
  const fg = color || tone || '#7a7060';
  const bgc = bg || (tone ? `${tone}1a` : '#f0ece2');
  // All chips render the label in its own capitalisation (Title/sentence
  // case). leading-[1.2] keeps descenders from clipping while staying compact.
  void size;
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold whitespace-nowrap px-2.5 py-[3px] text-[11px] leading-[1.2] ${className}`}
      style={{ background: bgc, color: fg, ...style }}
      {...rest}
    >
      {children}
    </span>
  );
}
